import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    Company,
    UserProvider,
    Auth,
    UtilityProvider,
    LanguageProvider,
} from '@lighty';
import {
    StorageService,
    AuthService,
    TranslateService,
    EmitterService,
    ExternalAppsService,
    RedirectService,
} from '@services';
import { CookieService } from 'ngx-cookie-service';
import { UrlHelper } from '@helpers';
import { find } from '@functions';
import { environment } from '@env/environment';
import { Language } from '@interfaces';
import { take, tap } from 'rxjs/operators';
import { CommonToastService } from '@common2/services/toast.service';
import { ThemingService } from '@common2/services/theming.service';
import Swiper, { Navigation, Pagination } from 'swiper';
@Component({
    selector: 'msc-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
    private hoveredStates: { [key: string]: boolean } = {}; // Estado de hover para cada empresa
    private me: any;
    private redirection: string;
    private customUrl: string;
    public display: any;
    public companies: Company[];
    public storedCompanies: Company[];
    public loginType: string = "normal";
    public query: string;
    public currentLang: Language;
    public companySelected: Company;
    public flagDropdown: boolean = false;
    public loading: boolean = false;
    public action: any;
    public writePassword: boolean = false;
    public displayPassword: boolean = false;
    public displayMessage: boolean = false;
    public message: string;
    public redirect_to: string;
    public role: string;
    public credentials: any = {
        email: '',
        password: '',
    };
    public selectData: any[] = [];
    slideConfig: any;
    public id: string;
    public loader: boolean = true;
    public ssoList: Array<any> = [];
    public baseUrl: string = '';
    public urlParams: any = null;
    public isValidating: boolean = false;
    public currentRoute: string = '';
    public currentUrlSegments: Array<any> = [];
    public domain: string = '';
    isOn: boolean; // Inicialmente en SSO
    public searchTerm: string = '';
    //mouse img
    backgroundPosition = '50% 50%';
    private targetX = 50;
    private targetY = 50;
    private currentX = 50;
    private currentY = 50;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private userProvider: UserProvider,
        private toastService: CommonToastService,
        private storageService: StorageService,
        private translateService: TranslateService,
        private emitterService: EmitterService,
        private externalAppsService: ExternalAppsService,
        private redirectService: RedirectService,
        private cookieService: CookieService,
        private utilityProvider: UtilityProvider,
        private languageProvider: LanguageProvider,
        private themingService: ThemingService
    ) {
        //this.domain = "https://ca.coronaaprende.com";
        //this.domain = "https://www.utesaplus.edu.do";
        this.domain = this.getBaseUrl();
        localStorage.setItem('baseUrl', this.domain);
    }

    ngAfterViewInit() {
        new Swiper('.swiper-container', {
            modules: [Pagination, Navigation],
            spaceBetween: 16,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                640: { slidesPerView: 2, spaceBetween: 12 },
                768: { slidesPerView: 3, spaceBetween: 16 }
            }
        }); // Cargar e iniciar particles.js
        if (this.loginType === 'normal') {
            setTimeout(() => this.initParticles(), 500);
        }
        //mouse img
        this.animateBackground();
    }

    //mouse img login
    onMouseMove(event: MouseEvent): void {
        const el = event.currentTarget as HTMLElement;
        const rect = el.getBoundingClientRect();

        const relX = (event.clientX - rect.left) / rect.width;
        const relY = (event.clientY - rect.top) / rect.height;

        const offsetX = (relX - 0.5) * 2; // de -1 a 1
        const offsetY = (relY - 0.5) * 2;

        const maxOffset = 10; // o usa this.maxOffset si prefieres mantenerlo como propiedad

        this.targetX = 50 + offsetX * maxOffset;
        this.targetY = 50 + offsetY * maxOffset;
    }

    //efct img login
    animateBackground(): void {
        const step = () => {
            // Interpolación suave
            this.currentX += (this.targetX - this.currentX) * 0.1;
            this.currentY += (this.targetY - this.currentY) * 0.1;

            this.backgroundPosition = `${this.currentX}% ${this.currentY}%`;

            requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
    }


    //PARTICULA TS 1
    loadParticlesScript(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (document.getElementById('particles-js-script')) {
                resolve(); // Script ya cargado
                return;
            }

            const script = document.createElement('script');
            script.id = 'particles-js-script';
            script.src = 'assets/scripts/particles.min.js';
            script.onload = () => resolve();
            script.onerror = () => reject('Error al cargar particles.js');
            document.body.appendChild(script);
        });
    }

    /**
     * PARTICULA TS-2 Inicializa el fondo animado de partículas en el div con id="particles-js"
     */
    initParticles(): void {
        this.loadParticlesScript()
            .then(() => {
                const el = document.getElementById('particles-js');
                if (el && (window as any).particlesJS) {
                    (window as any).particlesJS('particles-js', {
                        particles: {
                            number: { value: 60, density: { enable: true, value_area: 800 } },
                            color: { value: "#dedede" },
                            shape: { type: "circle" },
                            opacity: { value: 0.5 },
                            size: { value: 4, random: true },
                            line_linked: {
                                enable: true,
                                distance: 150,
                                color: "#a9afba",
                                opacity: 0.4,
                                width: 1
                            },
                            move: {
                                enable: true,
                                speed: 2,
                                direction: "none",
                                random: false,
                                straight: false,
                                bounce: false
                            }
                        },
                        interactivity: {
                            detect_on: "canvas",
                            events: {
                                onhover: { enable: true, mode: "grab" },
                                onclick: { enable: true, mode: "push" },
                                resize: true
                            },
                            modes: {
                                grab: { distance: 140, line_linked: { opacity: 1 } },
                                push: { particles_nb: 4 }
                            }
                        },
                        retina_detect: true
                    });
                } else {
                    console.error('particlesJS no está disponible');
                }
            })
            .catch(error => console.error(error));
    }


    isHovered(slug: string): boolean {
        return this.hoveredStates[slug] || false;
    }

    setHovered(slug: string, value: boolean): void {
        this.hoveredStates[slug] = value;
    }

    ngOnInit(): void {
        this.slideConfig = {
            slidesPerView: 'auto',
            spaceBetween: 16,
            navigation: {
                prevEl: '.prev-btn',
                nextEl: '.next-btn',
            },
            pagination: {
                clickable: true,
            },
            breakpoints: {
                '360': { slidesPerView: 5, spaceBetween: 8 }, // 1 tarjeta por fila en móviles
                '490': { slidesPerView: 5, spaceBetween: 10 }, // 2 tarjetas por fila
                '718': { slidesPerView: 5, spaceBetween: 10 }, // 3 tarjetas por fila
                '1022': { slidesPerView: 4, spaceBetween: 16 }, // 4 tarjetas por fila
                '1486': { slidesPerView: 5, spaceBetween: 16 }, // 5 tarjetas por fila
            },
            allowTouchMove: false, // Desactiva el desplazamiento táctil
        };


        const setLang = this.storageService.get('lang');
        if (setLang) {
            this.translateService.setLang(setLang);
        }
        this.utilityProvider.checkMaintenance().subscribe((data) => {
            if (data.state) {
                this.router.navigate(['maintenance']);
            }
        });
        this.route.params.subscribe((params) => {
            if (params.type === 'company') {
                this.loginType = 'company';
                this.me = this.route.snapshot.data.me;
                this.setLanguages(this.me.language.code);
                this.companies = this.route.snapshot.data.companies;
                this.storedCompanies = this.route.snapshot.data.companies;
                this.companySelected =
                    this.companies.length > 0 ? this.companies[0] : null;
                this.display = this.route.snapshot.data.display;
                this.isOn = !this.display.ssoFirst;
                this.processFavicon();
                this.action = {
                    back: false,
                    next: true,
                    index: 0,
                };
                if (!this.storageService.get('me')) {
                    this.storageService.set('me', this.me);
                }
                this.externalAppsService.freshchat('shutdown');

                if (this.externalAppsService.beamer()) {
                    this.externalAppsService.unboot('beamer');
                    this.externalAppsService.beamer().destroy();
                }
                this.checkIfRedirect();
            } else {
                const code = this.translateService.getCurrentLang();
                this.display = this.route.snapshot.data.display;
                this.isOn = !this.display.ssoFirst;
                this.setLanguages(code);
                this.processFavicon();
                const timeOut = setTimeout(() => {
                    this.loginType = 'normal';
                    clearTimeout(timeOut);
                }, 200);
            }
            this.emitterService.set(
                'theme.change',
                this.display && this.display.colorTemplate
                    ? this.display.colorTemplate
                    : {}
            );
        });
        this.route.queryParams.subscribe((params) => {
            this.redirection = this.storageService.get('redirect') || null;
            this.credentials.email = params.email || null;
            this.customUrl = params.custom_url;
            this.redirect_to = params.redirect_to;
            this.role = params.role;
            if (params.accessToken && params.refreshToken && params.redirect) {
                this.authService.createCookies({
                    access_token: params.accessToken,
                    refresh_token: params.refreshToken,
                } as any);
                window.location.href = params.redirect;
            }
            if (this.credentials.email) {
                const timeOut = setTimeout(() => {
                    find('#login').click();
                    clearTimeout(timeOut);
                }, 250);
            }
        });
        ////On custom domain URL
        // check common url
        if (location.origin !== environment.envVar.APP_URL) {
            const idParam = this.route.snapshot.paramMap.get('id');

            if (idParam) {
                console.log("Por acá paso con ID");
                this.id = idParam;
                this.route.url.pipe(take(1)).subscribe((url) => {
                    this.currentUrlSegments = url;
                    if (url[0].path === 'sso') {
                        localStorage.setItem('ssoKey', this.id);
                    }
                });

                this.route.queryParams.pipe(take(1)).subscribe((urlParams) => {
                    const hasParams = JSON.stringify(urlParams).length > 2;

                    if (this.id) {
                        this.authService.getSso(this.id).pipe(take(1)).subscribe({
                            next: (data) => {
                                this.baseUrl = data.baseUrl;
                                this.ssoList = data.data;
                            },
                            error: (err) => {
                                console.warn('Error en getSso con ID:', err);
                            },
                            complete: () => {
                                setTimeout(() => {
                                    this.loader = false; // <--- FINALIZA SIEMPRE
                                }, 1000);
                            }
                        });
                    }

                    if (hasParams && Object.prototype.hasOwnProperty.call(urlParams, 'validate') && !this.currentUrlSegments.some(obj => obj.path === 'company')) {
                        const currentTheme = JSON.parse(localStorage.getItem('theme') || '{}');
                        if (currentTheme) {
                            this.themingService.apply({
                                ...(currentTheme?.colorTemplate?.primaryColor && { primary: currentTheme.colorTemplate.primaryColor }),
                                ...(currentTheme?.colorTemplate?.secondaryColor && { secondary: currentTheme.colorTemplate.secondaryColor }),
                            });
                        }

                        this.isValidating = true;
                        const params = { uuid: urlParams.validate };

                        this.authService.validateSsoAccount(params).pipe(take(1)).subscribe({
                            next: (data) => {
                                this.authService.createCookies({
                                    access_token: data.accessToken,
                                    refresh_token: data.refreshToken,
                                } as any);
                                this.router.navigate(['login', 'company'], {
                                    queryParamsHandling: 'merge',
                                });
                            },
                            error: (err) => {
                                const code = err?.error?.httpCode;
                                const msg = err?.error?.message;
                                if (code === 404 && msg === 'brandId') {
                                    this.toastService.onError(this.translateService.instant('toast.login.404.brandId'));
                                } else if (code === 404) {
                                    this.toastService.onError(this.translateService.instant('toast.login.404.number'));
                                } else if (code === 401) {
                                    this.toastService.onError(this.translateService.instant('toast.login.401'));
                                }
                                this.isValidating = false;
                            },
                            complete: () => {
                                this.isValidating = false;
                            }
                        });
                    }
                });

            } else {
                // No hay ID en URL -> Validar por dominio personalizado
                console.log("Por acá paso 2 sin ID");

                this.authService.validateCustomUrlSso({ url: this.domain }).pipe(take(1)).subscribe({
                    next: (data) => {
                        this.id = data.uuid;
                        if (this.id) {
                            this.authService.getSso(data.uuid).pipe(take(1)).subscribe({
                                next: (sso) => {
                                    this.baseUrl = sso.baseUrl;
                                    this.ssoList = sso.data;
                                },
                                error: (e) => {
                                    console.warn('Error en getSso (custom):', e);
                                },
                                complete: () => {
                                    setTimeout(() => {
                                        this.loader = false; // <--- FINALIZA SIEMPRE
                                    }, 1000);
                                }
                            });
                        } else {
                            setTimeout(() => {
                                this.loader = false; // <--- FINALIZA SIEMPRE
                            }, 1000);
                        }
                    },
                    error: (err) => {
                        console.warn('Error en validateCustomUrlSso:', err);
                        setTimeout(() => {
                            this.loader = false; // <--- FINALIZA SIEMPRE
                        }, 1000);
                    }
                });
            }

        } else {
            // No es dominio personalizado: apaga loader directo
            setTimeout(() => {
                this.loader = false; // <--- FINALIZA SIEMPRE
            }, 1000);
        }
        //PARTICULA TS-3
        if (this.loginType === 'normal') {
            setTimeout(() => this.initParticles(), 300); // Espera para que el DOM lo monte
        }
    }

    //Switcher login
    toggleSwitcher() {
        this.isOn = !this.isOn;
    }




    getSelectData(languages: Language[], code) {
        return languages.map((language, index) => {
            const id = index;
            const label = language.name;
            const value = language;
            const isSelected = language.code === code;
            return { id, label, value, isSelected };
        });
    }
    onSelectOption(option) {
        this.selectData = this.selectData.map((selectDatum) => {
            selectDatum.isSelected = selectDatum.id === option.id;
            return selectDatum;
        });
        this.onSelect(option.value);
    }
    setLanguages(code: string = 'en') {
        this.languageProvider
            .get('interface')
            .pipe(tap((response) => this.onTapSetLanguages(response, code)))
            .subscribe();
    }
    onTapSetLanguages(languages: Language[], code: string) {
        if (!Array.isArray(languages)) {
            return;
        }
        this.currentLang =
            languages.find((language) => language.code === code) ||
            languages[0];
        this.storageService.set('lang', this.currentLang.code);
        this.translateService.setLang(this.currentLang.code);
        this.selectData = this.getSelectData(languages, code);
        this.processMessage();
    }
    processMessage(): void {
        this.message = this.display?.loginMessages?.find(
            (loginMessage: any) => {
                return loginMessage.languageId === this.currentLang.id;
            }
        )?.message;
    }
    processFavicon(): void {
        if (this.display?.url?.media) {
            this.emitterService.set(
                'favicon.change',
                this.display.url.media.pictureUrl
            );
        }
    }
    getMaxHeight(): string {
        if (this.displayMessage) {
            const view: any = document.querySelector('.froala-view');
            return view.offsetHeight + 'px';
        }
        return '150px';
    }
    hasDifferentHeight(): boolean {
        const view: any = document.querySelector('.froala-view');

        return view.offsetHeight > 200;
    }
    checkIfRedirect(): void {
        if (this.storedCompanies.length === 1) {
            if (this.companySelected.roles.length === 1) {
                this.roleToRedirect(this.companySelected.roles[0]);
            }
        }
    }
    roleToRedirect(role: string) {
        switch (role) {
            case 'company_learner':
                this.redirect('learn');
                break;
            case 'company_author':
                this.redirect('create');
                break;
            case 'company_manager':
                this.redirect('manage');
                break;
            case 'company_administrator':
                this.redirect('organize');
                break;
        }
    }
    trimPassword(): void {
        this.credentials.password = this.credentials.password.trim();
    }
    login(): void {
        this.loading = true;
        if (this.writePassword) {
            this.credentials['base_url'] = this.getBaseUrl();
            localStorage.setItem('baseUrl', this.getBaseUrl());
            this.authService.login(this.credentials).subscribe(
                (auth: Auth) => {
                    if (auth.forcedPasswordReset) {
                        this.router.navigate(['password', 'reset'], {
                            queryParams: {
                                email: this.credentials.email,
                                token: auth.forcedPasswordReset,
                            },
                        });
                    } else {
                        const timeOut = setTimeout(() => {
                            this.loading = false;
                            clearTimeout(timeOut);
                        }, 1500);
                        if (this.redirection) {
                            this.router.navigateByUrl(this.redirection);
                        } else {
                            this.router.navigate(['login', 'company'], {
                                queryParamsHandling: 'merge',
                            });
                        }
                    }
                },
                (failure) => {
                    if (
                        typeof failure.error === 'string' &&
                        failure.error.indexOf('Company prefix missing') > -1
                    ) {
                        this.toastService.onError(
                            this.translateService.instant(
                                'toast.company.prefix.missing'
                            )
                        );
                    } else if (failure.status === 403) {
                        this.toastService.onError(
                            this.translateService.instant(
                                'toast.login.many.attempts'
                            )
                        );
                    } else if (failure.status === 204) {
                        this.toastService.onError(
                            this.translateService.instant(
                                'toast.invalid-credentials'
                            )
                        );
                    } else if (failure.status === 400) {
                        this.toastService.onError(
                            this.translateService.instant(
                                'toast.invalid-credentials'
                            )
                        );
                    } else if (failure.status === 401) {
                        this.toastService.onError(
                            this.translateService.instant(
                                'toast.account-disabled'
                            )
                        );
                    } else if (failure.status === 405) {
                        this.toastService.onError(
                            this.translateService.instant(
                                'toast.login.not.allow'
                            )
                        );
                    }
                    this.loading = false;
                }
            );
        } else {
            const params = {
                origin: this.customUrl
                    ? this.customUrl
                    : this.redirection
                        ? UrlHelper.getUrl() + this.redirection
                        : UrlHelper.getUrl(),
                email: this.credentials.email,
            };
            this.authService.authenticateMethod(params).subscribe(
                (data) => {
                    if (data.type === 'sso') {
                        if (data.method === 'saml') {
                            // if (data.protocol === 'saml') {     temporary disable new cloud
                            this.samlForm(data.params, data.url);
                        } else {
                            UrlHelper.navigate(
                                {
                                    parts: [data.url],
                                    params: { state: data.params.state },
                                },
                                this.customUrl ? '_blank' : '_self'
                            );
                        }
                    } else {
                        this.writePassword = true;
                        this.loading = false;
                        const timeOut = setTimeout(() => {
                            find('#password').focus();
                            clearTimeout(timeOut);
                        }, 100);
                    }
                },
                () => {
                    this.loading = false;
                }
            );
        }
    }
    displayed(): void {
        this.flagDropdown = !this.flagDropdown;
    }
    displayedPassword(): void {
        this.displayPassword = !this.displayPassword;
    }
    displayedMessage(): void {
        this.displayMessage = !this.displayMessage;
    }
    search(query?): void {
        this.query = query;
        if (this.query) {
            this.companies = this.storedCompanies.filter((company: Company) => {
                const query = company.name
                    .toLowerCase()
                    .match(this.query.toLowerCase());

                if (query) {
                    return query;
                } else if (
                    company.experience &&
                    company.experience.displayName
                ) {
                    return company.experience.displayName
                        .toLowerCase()
                        .match(this.query.toLowerCase());
                } else {
                    return null;
                }
            });
        } else {
            this.companies = this.storedCompanies;
        }
    }

    //** card logo company */
    getCompanyLogo(company: Company): string {
        const rawUrl = company.experience?.displayPicture || company.picture;
        let url = rawUrl ? `${rawUrl}?size=256` : 'https://webservices.griky.co/cdn/img/Griky-Logotipo.webp';

        if (!environment.production && rawUrl) {
            url = url.replace(
                "https://api-upgraded.myskillcamp.com.deltabluecdn.com",
                "https://api.myskillcamp.com"
            );
        }

        return url;
    }
    //** logo login img */
    get logoUrl(): string {
        const rawUrl = this.display?.logo;
        let url = rawUrl ? `${rawUrl}?size=512` : 'https://webservices.griky.co/cdn/img/Griky-Logotipo.webp';

        if (!environment.production && rawUrl) {
            url = url.replace(
                "https://api-upgraded.myskillcamp.com.deltabluecdn.com",
                "https://api.myskillcamp.com"
            );
        }

        return url;
    }
    //** background login img */
    get backgroundUrl(): string {
        const rawUrl = this.display?.background;
        let url = rawUrl
            ? `${rawUrl}?size=1024`
            : 'https://conocimiento.griky.co/hubfs/Imagenes%20de%20Blog%20%281%29.png';

        if (!environment.production && rawUrl) {
            url = url.replace(
                'https://api-upgraded.myskillcamp.com.deltabluecdn.com',
                'https://api.myskillcamp.com'
            );
        }

        return url;
    }
    //** text company img */
    get companyName(): string {
        if (!this.display) {
            return 'Griky'; // Valor por defecto
        }

        const expName = this.display.experience?.displayName;
        const name = this.display.name;

        if (expName && expName !== name) {
            return expName;
        }

        return name || 'Griky';
    }

    get welcomeCustomMessage(): string {
        if (!this.display) {
            return null; // Valor por defecto
        }
        return this.display.welcomeCustomMessage ? this.display.welcomeCustomMessage : null;
    }

    /**
     * @deprecated
     * @param company
     */
    selectCompany(company: Company): void {
        this.companySelected = company;
        if (this.role && this.isRole(this.role)) {
            this.roleToRedirect(this.role);
        }
    }
    /**
     * Pasar el slug
     * role owner excluir
     * @param type
     * @param idCompany
     */
    redirect(type: string): void {
        const slug = this.companySelected.slug;
        this.cookieService.set(
            'current_company',
            slug,
            10,
            '/',
            UrlHelper.getDomain(),
            false,
            'Lax'
        );
        this.userProvider.me().subscribe((data) => {
            this.isValidating = false;
            this.storageService.set('me', data);
            this.event(type);
            switch (type) {
                case 'create':
                    this.redirectService.navigate('studio', [
                        'company',
                        slug,
                        'home',
                    ]);
                    break;
                case 'learn':
                case 'manage':
                case 'organize':
                    let url = [type, slug];
                    if (this.redirect_to) {
                        // url.push(this.redirect_to);
                        url = [...url, ...this.redirect_to.split(',')];
                    }
                    this.router.navigate(url);
                    break;
            }
        });
    }
    event(type: string): void {
        let role = '';
        switch (type) {
            case 'learn':
                role = 'learner';
                break;
            case 'create':
                role = 'author';
                break;
            case 'manage':
                role = 'manager';
                break;
            case 'organize':
                role = 'administrator';
                break;
        }
    }
    isRole(type: string): boolean {
        return (
            this.companySelected.roles.findIndex((role) => {
                return role === type;
            }) !== -1
        );
    }
    /*passwordForgotten(): void {
        let storedTheme = JSON.parse(localStorage.getItem('theme'));
        this.router.navigate(['password', 'forgotten'], { queryParams: { email: this.credentials.email } });
    }*/

    passwordForgotten(): void {
        const storedTheme = JSON.parse(localStorage.getItem('theme') || '{}');

        if (storedTheme && storedTheme.urlPasswordReset) {
            const redirectUrl = storedTheme.urlPasswordReset;

            // Si la URL es externa
            if (redirectUrl.startsWith('http')) {
                window.location.href = `${redirectUrl}?email=${this.credentials.email}`;
            } else {
                // Si la URL es interna, usa Router para navegar
                this.router.navigate([redirectUrl], {
                    queryParams: { email: this.credentials.email },
                });
            }
        } else {
            console.error(
                'No se encontró "urlPasswordReset" en el tema almacenado'
            );
            // Opcional: Redirección predeterminada si no se encuentra `urlPasswordReset`
            this.router.navigate(['password', 'forgotten'], {
                queryParams: { email: this.credentials.email },
            });
        }
    }

    logout(): void {
        this.emitterService.set('global.logout', { full: true });
        setTimeout(() => {
            document.getElementById('chatbase-bubble-button').style.display =
                'none';
        }, 1000);
    }
    samlForm(params: any, url: string): void {
        const form = document.createElement('form');
        form.target = '_blank';
        form.method = 'POST';
        form.action = url;
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.setAttribute('value', params[key]);
                form.appendChild(input);
            }
        }
        document.body.appendChild(form);
        form.submit();
    }
    onSelect(language: Language): void {
        this.currentLang = language;
        this.translateService.setLang(this.currentLang.code);
        this.processMessage();
    }
    public getBaseUrl(): string {
        const currentUrl = window.location.href;
        const urlParts = currentUrl.split('/');
        const baseUrl = `${urlParts[0]}//${urlParts[2]}`;
        return baseUrl;
    }
}
